import { render, staticRenderFns } from "./RegViewApps.vue?vue&type=template&id=30f7bb72"
import script from "./RegViewApps.vue?vue&type=script&lang=js"
export * from "./RegViewApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports